/* eslint-disable @typescript-eslint/ban-ts-comment */
import { InputLabelProps, TextField, TextFieldProps } from '@mui/material'
import React, { FC } from 'react'
import { Controller, UseControllerProps, useFormContext } from 'react-hook-form'
import Mask, { Props as MaskProps } from 'react-input-mask'

type FormFieldMaskProps = Omit<UseControllerProps, 'control'> &
    Omit<MaskProps, 'size'> &
    TextFieldProps & {
        name: string
        size?: 'small' | 'medium'
        unHelperText?: boolean
    }

export const FormFieldMask: FC<FormFieldMaskProps> = ({
    InputLabelProps: inputLabelProps,
    alwaysShowMask,
    beforeMaskedStateChange,
    disabled: disableMask,
    mask,
    maskPlaceholder,
    maskChar,
    name,
    onChange,
    rules,
    size,
    variant = 'filled',
    unHelperText,
    defaultValue,
    ...rest
}) => {
    const { control } = useFormContext()
    const disabled = disableMask || (control as any)._options?.disabled

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange({
                ...event,
                target: {
                    ...event.target,
                    value: event.target.value,
                },
            })
        }
    }

    const handleInputLabelProps = (value: string | undefined) => {
        const inputLabelPropsValue: InputLabelProps = {}
        if (inputLabelProps) {
            if (value && value.length > 0) {
                inputLabelPropsValue.shrink = true

                return inputLabelPropsValue
            }

            return inputLabelProps
        }

        if (value && value.length > 0) {
            inputLabelPropsValue.shrink = true
        }

        return inputLabelPropsValue
    }

    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            defaultValue={defaultValue}
            render={({
                field: { onChange, value, ...field },
                fieldState: { error },
            }) => (
                <Mask
                    {...field}
                    name={name}
                    mask={mask}
                    maskChar={maskChar}
                    maskPlaceholder={maskPlaceholder}
                    alwaysShowMask={alwaysShowMask}
                    beforeMaskedStateChange={beforeMaskedStateChange}
                    value={value}
                    onChange={e => {
                        const { value } = e.target
                        e.persist()
                        onChange(value)
                        handleChange(e)
                    }}
                    disabled={disabled}
                >
                    {
                        // @ts-ignore
                        (props: any) => (
                            <TextField
                                {...props}
                                {...rest}
                                fullWidth
                                error={!!error}
                                variant={variant}
                                disabled={disabled}
                                size={size}
                                InputLabelProps={handleInputLabelProps(value)}
                                helperText={
                                    error && !unHelperText
                                        ? error.message
                                        : props?.helperText
                                          ? props.helperText
                                          : unHelperText
                                            ? null
                                            : ' '
                                }
                            />
                        )
                    }
                </Mask>
            )}
        />
    )
}
